export const EMPLOYMENT_TYPE_LABEL = {
	fullTime: { key: 'Full time', value: 'fullTime' },
	partTime: { key: 'Part time', value: 'partTime' },
};

export const DEFAULT_VALUES = {
	employmentType: '',
	from: '',
	fromTime: '',
};
